import React from 'react';
import ReactDOM from 'react-dom';
import { GlobalProvider } from '@/components/global-provider';
import './index.css';

import '@/lib/immer';

const root = document.getElementById('root');
ReactDOM.render(<GlobalProvider defaultIntlMessages={{}} />, root);
